// extracted by mini-css-extract-plugin
export default {"container":"SG-z","disabled":"TG-z","bgBlack":"UG-z","content":"VG-z","countdown":"WG-z","topCaption":"XG-z","topHeading":"YG-z","heading":"ZG-z","copy":"_G-z"};